/**
 * Shared Error Display Component
 */

import React from 'react';
import { Card, Flex, Button, useTheme, spacing } from '@fti/design-system';
import type { ApiError } from '../../api/types';

export function ErrorDisplay({ error, onRetry }: { error: ApiError; onRetry?: () => void }) {
  const { theme } = useTheme();

  return (
    <Card variant="outlined" padding="md">
      <Flex direction="column" align="center" gap="md">
        <div style={{ color: theme.colors.semantic.error.default, fontSize: '1.2rem', fontWeight: 600 }}>
          {error.isAuthError ? 'Access Denied' : 'Something went wrong'}
        </div>
        <div style={{ color: theme.colors.text.primary, textAlign: 'center', fontSize: '0.9rem' }}>
          {error.message}
        </div>
        {onRetry && error.canRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            Try Again
          </Button>
        )}
      </Flex>
    </Card>
  );
}
